import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { Navbar, Nav, Container, Button } from "react-bootstrap";
import { auth, ALLOWED_EMAIL } from "./firebase";
import { onAuthStateChanged, signOut } from "firebase/auth";
import Acasa from "./acasa";
import Comenzi from "./comenzi";
import Documente from "./documente";
import Login from "./Login";
import Rapoarte from "./rapoarte";

const App = () => {
  const [comenziSelectata, setComandaSelectata] = useState(null);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser && currentUser.email !== ALLOWED_EMAIL) {
        await signOut(auth);
        setUser(null);
        setLoading(false);
        return;
      }
      setUser(currentUser);
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  const handleLogout = async () => {
    await signOut(auth);
    setUser(null);
  };

  const deschideDocumente = (comanda) => {
    setComandaSelectata(comanda);
  };

  if (loading) return <div className="text-center mt-5">Se încarcă...</div>;
  if (!user) return <Login setUser={setUser} />;

  return (
    <BrowserRouter>
      <Navbar style={{ backgroundColor: "#1f2937" }} variant="dark" expand="lg">
        <Container>
          <Navbar.Brand>Fenestra ERP</Navbar.Brand>
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/">
              Acasa
            </Nav.Link>
            <Nav.Link as={Link} to="/comenzi">
              Comenzi
            </Nav.Link>
            <Nav.Link as={Link} to="/rapoarte">
              Rapoarte
            </Nav.Link>
          </Nav>
          <Nav>
            <Navbar.Text className="text-white me-3">{user.email}</Navbar.Text>
            <Button variant="outline-light" size="sm" onClick={handleLogout}>
              Deconectare
            </Button>
          </Nav>
        </Container>
      </Navbar>
      <Container className="mt-4">
        <Routes>
          <Route path="/" element={<Acasa />} />
          <Route
            path="/comenzi"
            element={<Comenzi deschideDocumente={deschideDocumente} />}
          />
          <Route
            path="/documente"
            element={
              <Documente
                comenziSelectata={comenziSelectata}
                deschideDocumente={deschideDocumente}
              />
            }
          />
          <Route path="/rapoarte" element={<Rapoarte />} />
        </Routes>
      </Container>
    </BrowserRouter>
  );
};

export default App;
